import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { AiOutlineHeart } from 'react-icons/ai'
import { watchlistService } from '../services/watchlist.service'
import MovieCard from '../views/MovieCard.jsx'

const MyList = () => {
  const navigate = useNavigate()
  const [list, setList] = useState(() => watchlistService.getAll())

  useEffect(() => {
    const sync = () => setList(watchlistService.getAll())
    window.addEventListener(watchlistService.EVENT, sync)
    return () => window.removeEventListener(watchlistService.EVENT, sync)
  }, [])

  const handleReadMore = (media) => {
    navigate(`/show/${media.id}`, {
      state: { media, fromSearch: false },
    })
  }

  return (
    <section id='my-list'>
      <div className='container movies-container'>
        <div className='section-head'>
          <span className='eyebrow'>Your collection</span>
          <h1>My List</h1>
          <p className='sub'>
            {list.length} saved title{list.length === 1 ? '' : 's'}.
          </p>
        </div>

        {list.length > 0 ? (
          <div className='movie-grid grid'>
            {list.map((media) => (
              <MovieCard
                key={media.id}
                media={media}
                onReadMore={handleReadMore}
              />
            ))}
          </div>
        ) : (
          <div className='empty-list'>
            <span className='empty-icon'>
              <AiOutlineHeart />
            </span>
            <h3>Your list is empty</h3>
            <p>Tap the heart on any title to save it here for later.</p>
            <a className='btn btn-primary' href='#/'>
              Browse titles
            </a>
          </div>
        )}
      </div>
    </section>
  )
}

export default MyList
